export default "__VITE_ASSET__BT23sV4A__"